import { createFeatureSelector, createSelector } from '@ngrx/store';

import {
  CurrentOrganizationUsersState,
  currentOrganizationUsersFeatureKey,
  selectAllUsers,
} from './current-organization-users.reducer';

export const selectUsersState = createFeatureSelector<CurrentOrganizationUsersState>(
  currentOrganizationUsersFeatureKey,
);

export const selectUsers = createSelector(selectUsersState, (state) => selectAllUsers(state.users));

export const selectUsersLoaded = createSelector(selectUsersState, (state) => state.usersLoaded);
